import { Button, Flex, Statistic } from "antd";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";

const Footer = () => {
    const dateDifference = Date.now() - new Date('09/07/2024').getTime();
    const days = Math.floor(dateDifference / (1000 * 60 * 60 * 24));

    return (
        <Flex vertical align="center" gap={20}>
            <i style={{ fontFamily: 'monospace', color: 'lightgray' }}>48.553561, -122.841868</i>
            <Flex align="center" gap={5}>
                Made with ❤️ by
                <Button type="dashed" href="https://n818pe.com" onClick={() => logEvent(analytics, 'Navigated to Ryan site')}>
                    Ryan Hunter
                </Button>
            </Flex>
            <Statistic title="The number of days I've loved you" value={days}/>
        </Flex>
    );
};

export default Footer;